module.exports = __webpack_public_path__ + "static/media/test11_2.9808fb4e.png";